import React, { useRef, useState } from "react";
import {
    GoogleMap,
    useLoadScript,
    Marker,
    Autocomplete,
} from "@react-google-maps/api";

const libraries = ["places"];
const mapContainerStyle = {
    width: "100%",
    height: "300px",
};
const defaultCenter = {
    lat: 19.7515,
    lng: 75.7139,
};

const LocationMap = ({
    setLatitude,
    setLongitude,
    setState,
    setCity,
    setPincode,
    setLocationAddress,
}) => {
    const [marker, setMarker] = useState(null);
    const [mapRef, setMapRef] = useState(null);
    const autocompleteRef = useRef(null);

    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: "AIzaSyBdiHm0zeGJmyPiGRsI3eJDqoTfWPBT9eM", // 🔑 replace with env var in production
        libraries,
    });

    const updateLocation = (lat, lng) => {
        const latlng = { lat, lng };
        setMarker(latlng);
        setLatitude(lat);
        setLongitude(lng);

        if (mapRef) {
            mapRef.panTo(latlng);
            mapRef.setZoom(14);
        }

        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: latlng }, (results, status) => {
            if (status === "OK" && results[0]) {
                const address = results[0].formatted_address;
                setLocationAddress(address);

                // Extract state, city, pincode from address components
                let state = "";
                let city = "";
                let pincode = "";

                results[0].address_components.forEach((component) => {
                    if (component.types.includes("administrative_area_level_1")) {
                        state = component.long_name;
                    }
                    if (component.types.includes("locality")) {
                        city = component.long_name;
                    }
                    if (component.types.includes("postal_code")) {
                        pincode = component.long_name;
                    }
                });

                setState(state);
                setCity(city);
                setPincode(pincode);
            } else {
                setLocationAddress("");
                setState("");
                setCity("");
                setPincode("");
                console.error("Geocoder failed due to: " + status);
            }
        });
    };

    const handleMapClick = (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        updateLocation(lat, lng);
    };

    const onPlaceChanged = () => {
        const place = autocompleteRef.current.getPlace();
        if (!place.geometry || !place.geometry.location) return;

        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        updateLocation(lat, lng);
    };

    const goToCurrentLocation = () => {
        if (!navigator.geolocation) {
            alert("Geolocation is not supported by your browser.");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;
                updateLocation(lat, lng);
            },
            () => {
                alert("Unable to retrieve your location.");
            }
        );
    };

    if (loadError) return <div>Error loading maps</div>;
    if (!isLoaded) return <div>Loading Maps...</div>;

    return (
        <div>
            {/* Search box + Current Location button */}
            <div style={{ marginBottom: "10px", display: "flex", gap: "8px" }}>
                <Autocomplete
                    onLoad={(ref) => (autocompleteRef.current = ref)}
                    onPlaceChanged={onPlaceChanged}
                >
                    <input
                        type="text"
                        placeholder="Search a location"
                        style={{
                            flex: 1,
                            padding: "10px",
                            fontSize: "16px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                        }}
                    />
                </Autocomplete>

                <button
                    onClick={goToCurrentLocation}
                    style={{
                        padding: "10px 15px",
                        fontSize: "14px",
                        cursor: "pointer",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        backgroundColor: "#f0f0f0",
                    }}
                    title="Use current location"
                >
                    📍 Current Location
                </button>
            </div>

            {/* Google Map */}
            <GoogleMap
                mapContainerStyle={mapContainerStyle}
                zoom={6}
                center={marker || defaultCenter}
                onClick={handleMapClick}
                onLoad={(map) => setMapRef(map)}
            >
                {marker && <Marker position={marker} />}
            </GoogleMap>
        </div>
    );
};

export default LocationMap;
